<script setup lang="ts">
import { ref } from 'vue'

import CollapsibleContent from '@fondof-ui/components/collapsible/CollapsibleContent.vue'
import { t } from '@shared/fondof-fn/translations/translations'
import { CollapsibleRoot } from 'radix-vue'

const props = defineProps<{
  initialOpen?: boolean
  content: string
}>()

const open = ref(props.initialOpen ?? false)
</script>

<template>
  <button
    v-if="!open"
    type="button"
    data-markdown-collapse-more
    @click.stop.prevent="open = true"
  >
    {{ t('showMore') }}
  </button>

  <CollapsibleRoot :open="open">
    <CollapsibleContent>
      <span
        data-markdown-collapse-content
        v-html="props.content"
      />
    </CollapsibleContent>
  </CollapsibleRoot>

  <button
    v-if="open"
    type="button"
    class="block"
    data-markdown-collapse-less
    @click.stop.prevent="open = false"
  >
    {{ t('showLess') }}
  </button>
</template>
